import { render, staticRenderFns } from "./agenda-verification-form.vue?vue&type=template&id=067c8eda&scoped=true&"
import script from "./agenda-verification-form.vue?vue&type=script&lang=js&"
export * from "./agenda-verification-form.vue?vue&type=script&lang=js&"
import style0 from "./agenda-verification-form.vue?vue&type=style&index=0&id=067c8eda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067c8eda",
  null
  
)

export default component.exports